import ChatWidget from "../components/ChatWidget";
import { useSettings } from "../lib/settings";
import { useEffect, useState } from "react";
import { api } from "../lib/api";

import { tr } from "../lib/i18n";
export default function ChatDemoPage() {
  const { settings } = useSettings();
  const [vehicle, setVehicle] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/vehicles", { params: { published: "true", limit: 1 } });
        if (data.items?.[0]) setVehicle(data.items[0]);
      } catch {}
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[hsl(var(--background))]">
      <div className="max-w-5xl mx-auto p-8 md:p-16">
        <div className="eyebrow">{tr("x.public_preview")}</div>
        <h1 className="text-4xl md:text-5xl font-semibold mt-1 tracking-tight" style={{ fontFamily: "Outfit" }}>
          {settings.showroom_name}
        </h1>
        <p className="text-[var(--gray-400)] mt-3 max-w-xl">
          {tr("x.this_page_is_a_stand_in_for_the_phase_3_")}
        </p>

        {vehicle && (
          <div className="panel p-6 mt-8 grid md:grid-cols-2 gap-6" data-testid="demo-vehicle-panel">
            {vehicle.photos?.[0]?.url && (
              <img src={vehicle.photos[0].url} alt="" className="rounded-lg w-full object-cover aspect-[4/3]" />
            )}
            <div>
              <div className="mono text-xs text-[var(--gray-400)]">{vehicle.stock_number}</div>
              <h2 className="text-2xl font-semibold mt-1" style={{ fontFamily: "Outfit" }}>{vehicle.make} {vehicle.model} {vehicle.model_year}</h2>
              <div className="text-sm text-[var(--gray-400)] mt-1">{vehicle.mileage?.toLocaleString()} {tr("x.km")} {vehicle.specification || "—"}</div>
              <div className="text-2xl font-bold mt-3 tabular">
                {settings.currency_symbol} {Number(vehicle.public_price || 0).toLocaleString("en-US", { minimumFractionDigits: settings.currency_decimals ?? 3, maximumFractionDigits: settings.currency_decimals ?? 3 })}
              </div>
              <p className="text-sm mt-4">{vehicle.description || tr("x.contact_us_for_full_details")}</p>
            </div>
          </div>
        )}
      </div>

      <ChatWidget vehicleId={vehicle?.id} vehicleLabel={vehicle ? `${vehicle.stock_number} · ${vehicle.make} ${vehicle.model} ${vehicle.model_year}` : null} />
    </div>
  );
}
